import App from './App.svelte';
import { DEFAULT_CHART_WIDTH } from './constants';

// To make it compatible with Observable
window.width = DEFAULT_CHART_WIDTH;

const app = new App({
	target: document.body
});

export default app;
